/**
 * Shared empty-feed copy for Add-component ghost preview and post-add editor
 * placeholders (Featured Carousel strip + LiB FeedSectionEmptyState).
 */

export type WebsiteFeedEmptyKind =
  | "loading"
  | "keyword"
  | "custom-pick-filtered"
  | "custom-pick-select-posts"
  | "custom-pick-select-products"
  | "group-filtered"
  | "group-select"
  | "by-the-day"
  | "trending-products"
  | "trending-content"
  | "platform"
  | "products"
  | "posts";

export function websiteEditorFeedEmptyMessage(
  kind: WebsiteFeedEmptyKind,
  opts?: { keywordPhrase?: string; platform?: string },
): string {
  switch (kind) {
    case "loading":
      return "Loading preview…";
    case "keyword": {
      const phrase = String(opts?.keywordPhrase || "").trim();
      return phrase
        ? `No posts match “${phrase}” yet.`
        : "No posts match these filters yet.";
    }
    case "custom-pick-filtered":
      return "No posts match these filters yet.";
    case "custom-pick-select-posts":
      return "Select posts in the panel to preview what will be added.";
    case "custom-pick-select-products":
      return "Select products in the panel to preview what will be added.";
    case "group-filtered":
      return "No components match these filters yet.";
    case "group-select":
      return "Select components in the panel to preview what will be added.";
    case "by-the-day":
      return "Select up to 3 days to preview this content.";
    case "trending-products":
      return "No trending products for this date range yet — once products get shop clicks they’ll show here.";
    case "trending-content":
      return "No trending content for this date range yet — once posts get clicks they’ll show here.";
    case "platform": {
      const platform = String(opts?.platform || "").trim();
      return platform
        ? `No ${platform} posts in preview yet — publish some to see them here.`
        : websiteEditorFeedEmptyMessage("posts");
    }
    case "products":
      return "No products in preview yet — publish some to see them here.";
    case "posts":
    default:
      return "No posts in preview yet — publish some to see them here.";
  }
}
